export const PAGES_STATE = 'pages'

export const CHANGE_PAGE = 'CHANGE_PAGE'
